import Link from "next/link";
import Styles from "./breadcrumb.module.css";
import BreadCrumbChild from "./breadcrumbChild";

const BreadCrumb = ({ breadcrumbData, customClass }) => {
  return (
    <div
      id="breadcrumb-section"
      className={`text-black text-2xl  left-0 sm:bottom-[2.5vw] z-10 ${customClass && customClass
        }`}
    >
      <div className="container">
        <div className={Styles.breadCrumb}>
          <Link href={"/"} className={Styles.breadCrumbLink}>
            Home
          </Link>
          <span className="lg:text-[1vw] inline-block px-3 lg:px-[0.3vw] align-middle">
            /
          </span>
          {breadcrumbData.map((item, i) => (
            <BreadCrumbChild key={i} item={item} isLast={i === breadcrumbData.length - 1} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default BreadCrumb;
